import { Button } from '@cottage/design-system/internal-tooling/ui'

interface GcpRecommendConfirmModalProps {
  open: boolean
  isRunning: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function GcpRecommendConfirmModal({
  open,
  isRunning,
  onClose,
  onConfirm,
}: GcpRecommendConfirmModalProps) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="gcp-recommend-confirm-title"
        className="relative w-full max-w-lg rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="gcp-recommend-confirm-title" className="text-sm font-semibold text-gray-900">
          Get recommendations?
        </h3>
        <div className="mt-4 space-y-2 text-sm text-gray-600">
          <p>
            This sends the current analysis run to Claude (Anthropic API) to produce a ranked action
            plan with estimated savings.
          </p>
          <p>If recommendations already exist, this run replaces them.</p>
          <p>It does not change any GCP resources.</p>
          <p>It uses API credits and typically takes about a minute.</p>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            gradient
            size="md"
            disabled={isRunning}
            onClick={onConfirm}
          >
            Get recommendations
          </Button>
        </div>
      </div>
    </div>
  )
}
